(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$stickyStateProvider', '$urlRouterProvider'];

    function stateConfig( $stateProvider, $stickyStateProvider, $urlRouterProvider ) {
        $stateProvider
            .state('release-notes', {
                parent: 'app',
                url: '/release-notes',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI'],
                    pageTitle: 'ccsTrApp.releaseNotes.home.title',
                    title: 'Release Notes'
                },
                views: {
                    'release-notes@': {
                        templateUrl: 'app/entities/release-notes/release-notes.html',
                        controller: 'ReleaseNotesController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function( $translate, $translatePartialLoader ) {
                        $translatePartialLoader.addPart('releaseNotes');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
        $stickyStateProvider.enableDebug( true );
    }
})();
